import axiosClient from "./axiosClient";

const getGridSector = async (x, y) => {
  return await axiosClient.get(`stadiums/section?x=${x}&y=${y}`);
};

export { getGridSector };
